// The admin panel's way into the game before the premiere, for this browser
// tab. The server checks the administrator claim on every command; this only
// skips the countdown.
const EARLY_KEY = 'mykart:kartlife:early-access';

export function grantEarlyAccess() {
  try { window.sessionStorage.setItem(EARLY_KEY, '1'); } catch { /* blocked storage: the countdown stays */ }
}

export function earlyAccess() {
  try { return window.sessionStorage.getItem(EARLY_KEY) === '1'; } catch { return false; }
}

// After a wipe this browser forgets the old run too: pending commands, the
// rail card's garage summary, read dialogs and the "already a player" mark.
// Keys naming another account (a long UID-like run) are left alone.
const namesOtherAccount = (key, uid) => /[A-Za-z0-9]{20,}/.test(key.split(uid).join(''));

export function forgetLocalKartLife(uid) {
  try {
    const keys = [];
    for (let i = 0; i < window.localStorage.length; i++) keys.push(window.localStorage.key(i));
    keys.filter(key => key && /kartlife/i.test(key) && !namesOtherAccount(key, uid))
      .forEach(key => window.localStorage.removeItem(key));
  } catch { /* blocked storage holds nothing to forget */ }
}

// Signing in from the signed-out countdown comes back to the game, also
// across Google's redirect, which keeps this tab's sessionStorage.
const RETURN_KEY = 'mykart:kartlife:return-after-login';

export function rememberKartLifeReturn() {
  try { window.sessionStorage.setItem(RETURN_KEY, '/kartlife'); } catch { /* blocked storage: the app chooser opens instead */ }
}

export function kartLifeReturn() {
  try { return window.sessionStorage.getItem(RETURN_KEY); } catch { return null; }
}

export function clearKartLifeReturn() {
  try { window.sessionStorage.removeItem(RETURN_KEY); } catch { /* nothing stored */ }
}
